enum ACLAuthority {
    NONE = 'NONE',
    READ = 'READ',
    WRITE = 'WRITE'
}

export default ACLAuthority;